import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './vehicle-model.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VehicleModelDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const vehicleModelEntity = useAppSelector(state => state.vehicleModel.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="vehicleModelDetailsHeading">
          <Translate contentKey="fleetSenseApp.vehicleModel.detail.title">VehicleModel</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{vehicleModelEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.vehicleModel.name">Name</Translate>
            </span>
          </dt>
          <dd>{vehicleModelEntity.name}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="fleetSenseApp.vehicleModel.type">Type</Translate>
            </span>
          </dt>
          <dd><Translate contentKey={`fleetSenseApp.VehicleTypeEnum.${vehicleModelEntity.type}`} /></dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.vehicleModel.description">Description</Translate>
            </span>
          </dt>
          <dd>{vehicleModelEntity.description}</dd>
          <dt>
            <span id="image">
              <Translate contentKey="fleetSenseApp.vehicleModel.image">Image</Translate>
            </span>
          </dt>
          <dd>
            {vehicleModelEntity.image ? (
              <div>
                {vehicleModelEntity.imageContentType ? (
                  <a onClick={openFile(vehicleModelEntity.imageContentType, vehicleModelEntity.image)}>
                    <img
                      src={`data:${vehicleModelEntity.imageContentType};base64,${vehicleModelEntity.image}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {vehicleModelEntity.imageContentType}, {byteSize(vehicleModelEntity.image)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="objectKey">
              <Translate contentKey="fleetSenseApp.vehicleModel.objectKey">Object Key</Translate>
            </span>
          </dt>
          <dd>{vehicleModelEntity.objectKey}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.vehicleModel.company">Company</Translate>
          </dt>
          <dd>{vehicleModelEntity.company ? vehicleModelEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/vehicle-model" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/vehicle-model/${vehicleModelEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VehicleModelDetail;
